module.exports = __webpack_public_path__ + "static/89-a58a73cc9439bc2ac78ffc8a6f35676f.png";